import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalVariablesService {

  private tela: string = "";
  private telaDetalhe: string = "";

  public get telaAtiva()
  {
    return this.tela;
  }

  public set telaAtiva(value: string)
  {
    this.tela = value;
  }

  public get telaDetalheAtiva()
  {
    return this.telaDetalhe;
  }

  public set telaDetalheAtiva(value:string)
  {
    this.telaDetalhe = value;
  }
  
}
